import React, { useEffect, useMemo, useState } from "react";
import {Container} from "react-bootstrap";
import StatsCard from "./Components/StatsCard/StatsCard";
import WelcomeHeader from "./Components/WelcomeHeader/WelcomeHeader";
import TurnaroundTime from "./Components/TurnaroundTime/TurnaroundTime";
import UnreadMessages from "./Components/UnreadMessages/UnreadMessages";
import "./styles/Dashboard.css";
import ChartCard from './Components/ChartCard/ChartCard';
import { getRevenueData, revenueCategories, chartColors, getOrdersData, ordersCategories, getStatsData, getTurnaroundData, getUnreadMessages} from "./utils/ChartData";

const Dashboard = () => {
  const [stats, setStats] = useState({
    clients: 0,
    orders: 0,
    turnAroundTime: 0,
    earnings: 0,
  });

  const [progress, setProgress] = useState({
    progClients: 0,
    progOrders: 0,
    progTurnAroundTime: 0,
    progEarnings: 0,
  });

  const [revenueData, setRevenueData] = useState([]);
  const [ordersData, setOrdersData] = useState([]);

  const [turnaroundEntries, setTurnaroundEntries] = useState([]);
  const [unreadMessages, setUnreadMessages] = useState([]);
  
    const revenueValues = useMemo(() => {
    if (!revenueData.length) return [];
    const latest = revenueData[revenueData.length - 1];
    return [
      latest.deliveries,
      latest.earnings,
      latest.pending,
      latest.refunds,
    ];
  }, [revenueData]);

    const ordersValues = useMemo(() => {
    if (!ordersData.length) return [];
    const latest = ordersData[ordersData.length - 1];
    return [
      latest.delivered,
      latest.fresh,
      latest.onhold,
      latest.revisions,
    ];
  }, [ordersData]);

  useEffect ( () => {
    const statsData = getStatsData();

    setStats({
      clients:(statsData[0].value),
      orders:(statsData[1].value),
      turnAroundTime:(statsData[2].value),
      earnings:(statsData[3].value),
    });

    setProgress({
      progClients:(statsData[0].progressValue),
      progOrders:(statsData[1].progressValue),
      progTurnAroundTime:(statsData[2].progressValue),
      progEarnings:(statsData[3].progressValue),
    });

    setRevenueData(getRevenueData());
    setOrdersData(getOrdersData());
    setTurnaroundEntries(getTurnaroundData());
    setUnreadMessages(getUnreadMessages());

  }, []);

  return (
    <Container fluid className="dashboard-content">
      <div className="container-fluid">
        <WelcomeHeader
          subtitle="Here's what's happening with your store today."
        />

        <div className="d-flex flex-wrap justify-content-start align-items-stretch gap-4 mb-4 mt-2">
          <StatsCard type="clients" value={stats.clients} progressValue={progress.progClients} />
          <StatsCard type="orders" value={stats.orders} progressValue={progress.progOrders} />
          <StatsCard type="tat" value={stats.turnAroundTime} progressValue={progress.progTurnAroundTime} />
          <StatsCard type="earnings" value={stats.earnings} progressValue={progress.progEarnings} />
        </div>

        {/* Charts */}
        <div className="row mb-4">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <ChartCard
              title="Revenue"
              data={getRevenueData()}
              categories={revenueCategories}
              colors={chartColors.revenue}
              values={revenueValues}
            />
          </div>
          <div className="col-lg-6">
            <ChartCard
              title="Orders Overview"
              data={getOrdersData()}
              categories={ordersCategories}
              colors={chartColors.orders}
              values={ordersValues}
            />
          </div>
        </div>
          <div className="row">
          <div className="col-lg-6 mb-lg-0">
            <TurnaroundTime data={getTurnaroundData()} />
          </div>
          <div className="col-lg-6">
            <UnreadMessages data={getUnreadMessages()}/>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Dashboard;
